/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.29",
    versionName: "0.2.0-nightly.2025.11.29",
    versionChannel: "nightly",
    buildDate: "2025-11-29T00:07:42.914Z",
    commitHash: "2cbe11c08359d381a9187677544245f302a2bdf7",
};
